export default __webpack_public_path__ + "static/articles-lutein-vijdame-5f47eda6dcb593aa52e7bdc37e2dd4b9.jpg";